import { useCallback, useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ApiClientContext } from 'common/contexts/api-client';
import { showToast } from 'store/redux/toast';
import { FAILED_PAYMENTS_STRINGS } from './failed-payments-strings';
import { fetchSelfResolvableFailedPayments } from './failed-payments-utils';
import type { ConsumerFailedPaymentModel } from './failed-payments.types';

const FAILED_PAYMENTS_ENDPOINT = '/v2/users/failed-payments';

type UseFailedPaymentsResult = {
  failedPayments: ConsumerFailedPaymentModel[];
  fetchFailedPayments: () => Promise<ConsumerFailedPaymentModel[] | null>;
};

export function useFailedPayments(): UseFailedPaymentsResult {
  const dispatch = useDispatch();
  const apiClient = useContext(ApiClientContext);
  const [failedPayments, setFailedPayments] = useState<
    ConsumerFailedPaymentModel[]
  >([]);

  const fetchFailedPayments = useCallback(async () => {
    const payments = await fetchSelfResolvableFailedPayments(() =>
      apiClient.get(FAILED_PAYMENTS_ENDPOINT),
    );
    if (payments === null) {
      dispatch(
        showToast(
          {
            message: FAILED_PAYMENTS_STRINGS['error.load_failed_payments'],
            error: true,
          },
          { autoDelete: true, autoDeleteTime: 5000 },
        ),
      );
      return null;
    }

    setFailedPayments(payments);
    return payments;
  }, [apiClient, dispatch]);

  return { failedPayments, fetchFailedPayments };
}
